// extracted by mini-css-extract-plugin
export var actions = "_mb-d";
export var benefitCard = "_mb-a";
export var benefitIcon = "_mb-b";
export var benefitLabel = "_mb-c";
export var benefits = "_mb-9";
export var bodyText = "_mb-8";
export var closeButton = "_mb-2";
export var content = "_mb-3";
export var eyebrow = "_mb-4";
export var heading = "_mb-5";
export var image = "_mb-f";
export var imagePanel = "_mb-e";
export var modal = "_mb-0";
export var shell = "_mb-1";
export var title = "_mb-6";
export var titleOffer = "_mb-7";